export default "__VITE_ASSET__CaViLDEs__"